<template>
  <div class="p-15">
    <el-form ref="ruleForm" :model="submitForm" :rules="rules" label-width="auto">
      <el-card header="基本信息">
        <el-form-item label="活动时间" prop="date_range">
          <el-date-picker
                  v-model="submitForm.date_range"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="请选择开始时间"
                  end-placeholder="请选择结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动名称" prop="title">
          <el-input v-model.trim="submitForm.title" placeholder="请输入活动名称，不超过30字" :maxlength="30" show-word-limit
                    class="el-input-cover"></el-input>
        </el-form-item>
      </el-card>
      <el-card header="奖品设置" class="m-t-20">
        <el-form-item label="分享上限" prop="rule.share_limit">
          <el-input v-model.number="submitForm.rule.share_limit" :min="0" placeholder="请输入分享上限不能为空，0表示不限制" type="number"
                    class="el-input-cover"></el-input>
        </el-form-item>
        <el-form-item label="兑奖期限" prop="rule.exchange_date_limit">
          <el-input v-model.number="submitForm.rule.exchange_date_limit" :min="0" placeholder="请输入活动发放礼品领奖截止天数（0表示不限制）"
                    type="number" class="el-input-cover"></el-input>
        </el-form-item>
        <el-form-item label="分享人数" prop="rule.condition">
          <el-input v-model.number="submitForm.rule.condition" :min="0" placeholder="请输入分享人数" type="number"
                    class="el-input-cover"></el-input>
        </el-form-item>
        <el-form-item label="分享奖励" required prop="awardSettings">
          <div v-for="(rule_item, rule_index) in submitForm.awardSettings" :key="rule_item.uuid" class="m-b-18 flex col-center">
            <prize-option @input="handleChangeOption(rule_index, rule_item)" v-model="rule_item.type" class="m-l-5" style="width: 192px"></prize-option>
            <el-form-item v-if="rule_item.type === CREDIT" :prop="'awardSettings.' + rule_index + '.quantity'" :rules="{
                required: true,
                message: '请输入积分',
                trigger: 'blur',
              }">
              <el-input v-model.number="rule_item.quantity" :placeholder="placeholder(rule_item)" type="number" :min="0" style="width: 250px" class="m-l-5 m-r-5"></el-input>
            </el-form-item>
            <el-form-item v-else :prop="'awardSettings.' + rule_index + '.optionId'" placeholder="谢谢参与"
                          :rules="{validator:(rule,value,callback)=>CHECK_OPTION(rule,value,callback,rule_item),trigger:['blur','change']}"
            >
              <el-select style="width: 250px" class="m-l-5 m-r-5" v-model="rule_item.optionId" filterable remote
                         reserve-keyword :placeholder="placeholder(rule_item)"
                         :disabled="prizeOptionDisabled(rule_item)"
                         :remote-method="(word) => remoteMethod(word, rule_index, rule_item)" :loading="loading">
                <el-option v-for="prizeOption in rule_item.prize_options" :key="prizeOption.id"
                           :label="prizeOption.title" :value="prizeOption.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :prop="'awardSettings.' + rule_index + '.stock'" :rules="{
                required: true,
                message: '请输入数量',
                trigger: 'blur',
              }">
              <el-input v-model.number="rule_item.stock" placeholder="活动数量" type="number" :min="0" style="width: 120px"
                        class="m-r-5"></el-input>
            </el-form-item>
            <i @click="removePrize(rule_index, rule_item)" class="el-icon-error fz-22 danger-color"></i>
          </div>
          <el-link @click="addPrize()" type="primary">添加奖励层级</el-link>
        </el-form-item>
      </el-card>
      <el-card header="产品设置">
        <el-form-item label="选择商品">
          <el-table class="table" :header-cell-style="tableHeaderStyle" :data="submitForm.products">
            <el-table-column prop="name" label="商品名称">
              <div slot-scope="scope" class="flex row">
                <div class="margin-left-xs">
                  <div>{{ scope.row.name }}</div>
                  <div class="text-red">¥{{ scope.row.price }}</div>
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="商品图片">
              <div slot-scope="scope">
                <img :src="scope.row.mainFileUrl" style="height: 50px"/>
              </div>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-link type="danger" @click="removeProduct(scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" style="margin-top: 10px" @click="showProductSelect">添加商品</el-button>
        </el-form-item>

        <el-form-item prop="products">
          <ec-product-select v-model="submitForm.products" ref="productselect" @submit="productSubmit"></ec-product-select>
        </el-form-item>
      </el-card>


      <el-card header="专题页设置">
        <el-form-item label="选择专题页">
          <el-table class="table" :header-cell-style="tableHeaderStyle" :data="submitForm.specialPages">
            <el-table-column prop="name" label="专题页标题">
              <div slot-scope="scope" class="flex row">
                <div class="margin-left-xs">
                  <div>{{ scope.row.title }}</div>
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="封面图">
              <div slot-scope="scope">
                <img :src="scope.row.coverImage" style="height: 50px"/>
              </div>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-link type="danger" @click="removeSpecialPage(scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" style="margin-top: 10px" @click="showSpecialPageSelect">添加专题页</el-button>
        </el-form-item>

        <el-form-item prop="specialPages">
          <ec-special-page-select v-model="submitForm.specialPages" ref="specialpageselect" @submit="specialPageSubmit"></ec-special-page-select>
        </el-form-item>

      </el-card>

      <el-card class="m-t-20">
        <tinymce ref="tinymce" v-model="submitForm.desc"></tinymce>
        <el-form-item label-width="0" class="m-t-20">
          <el-button @click="submit" :loading="loading" type="primary">立即提交</el-button>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import _ from "lodash";
import Tinymce from "@/components/Tinymce";
import PrizeOption from "@/views/Interaction/components/prize-option";
import {CREDIT, PRIZE_TYPE} from "@/enums/interaction";
import {cloneDeep, random} from "lodash";
import {
  createShareActivity,
  getPrizeOption,
  shareDocument,
  updateShareActivity,
} from "@/api/interaction";

export default {
  name: "share-detail",
  components: {
    Tinymce,
    PrizeOption,
  },
  computed: {
    placeholder() {
      return (rule_item) => {
        return rule_item.type
            ? PRIZE_TYPE.find((option) => option.value === rule_item.type).desc
            : "谢谢参与";
      };
    },
    prizeOptionDisabled() {
      return (rule_item) => {
        return rule_item.type === 'none'
      }
    }
  },
  watch: {
    'submitForm.date_range': function (val) {
      const [start_time, end_time] = val
      this.submitForm.startTime = start_time
      this.submitForm.endTime = end_time
    }
  },
  data() {
    return {
      loading: false,

      submitForm: {
        startTime: undefined,
        endTime: undefined,
        title: undefined,
        rule: {share_limit: undefined, exchange_date_limit: undefined, condition: undefined},
        products: [],
        productRange: [],
        specialPages: [],
        specialPageRange: [],
        desc: undefined,
        awardSettings: [],
        date_range: []
      },

      rules: {
        date_range: [{required: true, message: '请选择活动时间', trigger: 'change', type: 'array'}],
        title: [
          {
            required: true,
            message: "请输入活动名称",
            trigger: ["blur", "change"],
          },
        ],
        "rule.condition": [
          {
            required: true,
            message: "请填入分享人数",
            trigger: ["blur", "change"],
          },
        ],
        "rule.share_limit": [
          {
            required: true,
            message: "请填入分享上限",
            trigger: ["blur", "change"],
          },
        ],
        "rule.exchange_date_limit": [
          {
            required: true,
            message: "请填入兑奖期限",
            trigger: ["blur", "change"],
          },
        ],
        "awardSettings" : [{
          validator : (rule, value, callback) => {
            if (!value.length && !this.submitForm.awardSettings.length ) {
              callback(new Error('请选择分享奖励'));
            }
            callback();
          },
        }],
        "products" : [{
          validator : (rule, value, callback) => {
            if (!this.submitForm.products.length && !this.submitForm.specialPages.length ) {
              callback(new Error('请选择商品或专题页设置'));
            }
            callback();
          },
        }],
        "specialPages" : [{
           validator : (rule, value, callback) => {
             if (!this.submitForm.specialPages.length && !this.submitForm.products.length ) {
               callback(new Error('请选择商品或专题页设置'));
             }
             callback();
           },
        }],
      },
      CREDIT,
      CHECK_OPTION
    };
  },
  methods: {
    removePrize(rule_index, rule_item) {
      console.info(rule_index)
      this.submitForm.awardSettings.splice(rule_index, 1)
    },
    removeProduct(item) {
      const index = _.findIndex(this.submitForm.products, (product) => {
        return product.id === item.id;
      });
      if (index >= 0) {
        const submitForm = _.cloneDeep(this.submitForm);
        submitForm.products.splice(index, 1);
        this.submitForm = submitForm;
      }
      this.$refs.ruleForm.validate();
    },
    removeSpecialPage(item) {
      const index = _.findIndex(this.submitForm.specialPages, (specialPage) => {
        return specialPage.id === item.id;
      });
      if (index >= 0) {
        const submitForm = _.cloneDeep(this.submitForm);
        submitForm.specialPages.splice(index, 1);
        this.submitForm = submitForm;
      }
      this.$refs.ruleForm.validate();
    },
    productSubmit(rows) {
      const submitForm = _.cloneDeep(this.submitForm);
      submitForm.products = _.uniqBy(
          [...submitForm.products, ...rows],
          (p) => p.id
      );
      this.submitForm = submitForm;
      this.$refs.ruleForm.validate();
    },
    specialPageSubmit(rows) {
      const submitForm = _.cloneDeep(this.submitForm);
      submitForm.specialPages = _.uniqBy(
              [...submitForm.specialPages, ...rows],
              (p) => p.id
      );
      this.submitForm = submitForm;
      this.$refs.ruleForm.validate();
    },
    showProductSelect() {
      this.$refs.productselect && this.$refs.productselect.show();
    },
    showSpecialPageSelect() {
      this.$refs.specialpageselect && this.$refs.specialpageselect.show();
    },
    tableHeaderStyle() {
      return "color:#000;font-wight:500;font-size:14px;height:35px;background-color:#e6e9f2;";
    },
    addPrize(type) {
      this.submitForm.awardSettings.push({
        ...RULE_TEMPLATE,
        type: type,
        uuid: random(0, 99999),
      });
    },
    submit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let form = cloneDeep(this.submitForm);
          form.awardSettings.forEach(item => {
            item.optionId = item.optionId || 0;
            item.quantity = item.quantity || 0;
            delete item.prize_options
            delete item.uuid
          })
          let productRange = [];
          form.products.forEach(item => {
            productRange.push(item.id)
          })
          form.productRange = Array.from(new Set(productRange))
          delete form.products;

          let specialPageRange = [];
          form.specialPages.forEach(item => {
            specialPageRange.push(item.id)
          })
          form.specialPageRange = Array.from(new Set(specialPageRange))
          delete form.specialPages;

          delete form.date_range
          delete form.status

          try {
            form.id
                ? await updateShareActivity(form)
                : await createShareActivity(form);

            this.$message.success("操作成功");
            this.$router.push("/interaction/share-activity");
          } finally {
            this.loading = false;
          }
        }
      });
    },
    async remoteMethod(word, rule_index, rule_item) {
      this.loading = true;
      try {
        const {collection} = await getPrizeOption({
          type: rule_item.type,
          title: `%${word}%`,
        });
        rule_item.prize_options = collection;
        rule_item.optionId = undefined;
        this.$set(this.submitForm.awardSettings, rule_index, rule_item);
      } finally {
        this.loading = false;
      }
    },
    async handleChangeOption(rule_index, rule_item) {
      this.loading = true;
      try {
        const {collection} = await getPrizeOption({type: rule_item.type});
        rule_item.prize_options = collection;
        rule_item.optionId = collection[0]?.id || undefined;
        this.$set(this.submitForm.awardSettings, rule_index, rule_item);
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    const {id} = this.$route.query;

    if (id) {
      let loading = this.$loading({text: "加载数据中。。。"});
      try {
        const {document} = await shareDocument(id);

        document.date_range = [document.startTime, document.endTime];

        for (const item of document.awardSettings) {
          item.uuid = random(0, 99999)
          if (item.optionId) {
            const {collection} = await getPrizeOption({id: item.optionId})
            item.prize_options = collection
          } else {
            item.optionId = undefined
          }
        }
        if (!document.specialPages) {
          document.specialPages = [];
        }
        if (!document.products) {
          document.products = [];
        }
        this.submitForm = {...document};
      } finally {
        loading.close();
      }
    }
  }
}
const RULE_TEMPLATE = {
  inviteNum: undefined,
  inviteLimit: undefined,
  photoUrl: undefined,
  type: "credit",
  stock: undefined,
  quantity: 1,
  optionId: 1,
  userDispatchSettingId: undefined,
};
const CHECK_OPTION = (rule, value, callback, rule_item) => {
  if (rule_item.type !== 'none' && value === undefined) {
    callback(new Error('请选择奖项'))
  }
  callback()
}
</script>

<style scoped>
</style>
